import axios from 'axios'

const api = axios.create({
  baseURL: '/api-interna/v2/gid',
  withCredentials: true,
  timeout: 120000,
})

// Gerenciador de cancelamento de requisições ativas
const activeControllers = new Set<AbortController>()

export const cancelAllPendingRequests = () => {
  activeControllers.forEach((controller) => {
    try {
      controller.abort()
    } catch {
      // Ignorar erros ao abortar
    }
  })
  activeControllers.clear()
}

api.interceptors.request.use((config: any) => {
  // Se a requisição não tiver um sinal próprio, associa a um AbortController rastreado
  const controller = new AbortController()
  if (!config.signal) {
    config.signal = controller.signal
  }
  config.__controller = controller
  activeControllers.add(controller)
  return config
})

api.interceptors.response.use(
  (response) => {
    const controller = (response.config as any)?.__controller
    if (controller) {
      activeControllers.delete(controller)
    }
    return response
  },
  (error) => {
    const controller = (error?.config as any)?.__controller
    if (controller) {
      activeControllers.delete(controller)
    }

    // Se for cancelamento disparado na troca de tela, silencia para não gerar alertas/toasts indevidos
    if (
      axios.isCancel(error) ||
      error?.name === 'CanceledError' ||
      error?.code === 'ERR_CANCELED'
    ) {
      return new Promise(() => { })
    }

    return Promise.reject(error)
  },
)

export default api

